'use client'

import {
  createContext,
  type FC,
  type PropsWithChildren,
  useContext,
} from 'react'

import { type RecommendationConfiguration } from '../recommendationGetConfiguration'

const Context = createContext<RecommendationConfiguration | undefined>(
  undefined,
)

export const useRecommendationConfigContext =
  (): RecommendationConfiguration => {
    const contextValue = useContext(Context)

    if (contextValue === undefined) {
      throw new Error('Recommendation config provider unavailable')
    }

    return contextValue
  }

type RecommendationConfigProviderProps = {
  value: RecommendationConfiguration
}

export const RecommendationConfigProvider: FC<
  PropsWithChildren<RecommendationConfigProviderProps>
> = ({ children, value }) => (
  <Context.Provider value={value}>{children}</Context.Provider>
)
